import HomeIcon from "@mui/icons-material/Home";
import SubAdminIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import UsersIcon from "@mui/icons-material/SupervisorAccount";
import TableViewOutlinedIcon from "@mui/icons-material/TableViewOutlined";
import DepartmentsIcon from "@mui/icons-material/Category";
import DiscountIcon from "@mui/icons-material/DiscountOutlined";
import ProductsIcon from "@mui/icons-material/ShoppingBagOutlined";
import ProductsOrdersIcon from "@mui/icons-material/TakeoutDiningOutlined";
import SupportIcon from "@mui/icons-material/SupportAgentOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsIcon from "@mui/icons-material/NotificationsActiveOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import AdminImg from "./assets/admin-img.svg";
import StarIcon from "@mui/icons-material/Star";
import { Rating } from "@mui/material";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import MessagesIcon from "@mui/icons-material/MailOutlineOutlined";
import InterpreterModeOutlinedIcon from "@mui/icons-material/InterpreterModeOutlined";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import CancellationRequests from "@mui/icons-material/CancelPresentationOutlined";
import ThumbsUpDownOutlinedIcon from "@mui/icons-material/ThumbsUpDownOutlined";
import moment from "moment";
import NotificationBadge from "./components/NotificationBadge/NotificationBadge";
import SparePartsIcon from "@mui/icons-material/ExtensionOutlined";

function getNameById(id) {
  for (const area of SaudiArabiaAreas) {
    if (area.areaId === id) {
      return {
        nameArabic: area.areaNameArabic,
        nameEnglish: area.areaNameEnglish,
      };
    }

    const governorate = area.governorates.find((gov) => gov.id === id);
    if (governorate) {
      return {
        nameArabic: governorate.nameArabic,
        nameEnglish: governorate.nameEnglish,
      };
    }
  }
  return null;
}

export const HomeColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "phoneNumber",
    headerName: "رقم الهاتف",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span
        style={{
          direction: "ltr",
          unicodeBidi: "isolate",
        }}
      >
        {params?.row?.phoneNumber}
      </span>
    ),
  },

  {
    field: "createdAt",
    headerName: "تاريخ و وقت التسجيل",
    minWidth: 220,
    headerAlign: "center",
    flex: 1,
    align: "center",
    renderCell: (paramas) => {
      const loginTime = moment(paramas?.row?.createdAt).locale("en");
      const timeString = loginTime.format("YYYY/MM/DD hh:mm");
      const amPm = loginTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },

  {
    field: "address",
    headerName: "العنوان",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return Array.isArray(params?.row?.address) &&
        params.row.address.length > 0
        ? `يوجد ${params.row.address.length} عنوان`
        : "لم يقم بادخال عنوان";
    },
  },
];

// Get area name by ID
const getAreaName = (areaId) => {
  const area = SaudiArabiaAreas.find((a) => a.areaId === areaId);
  return area ? area.areaNameArabic : areaId;
};

// Get governorate name by ID
const getGovernorateName = (govId) => {
  // Search through all areas to find the governorate
  for (const area of SaudiArabiaAreas) {
    const gov = area.governorates?.find((g) => g.id === govId);
    if (gov) {
      return gov.nameArabic;
    }
  }
  return govId; // Return the ID if not found
};

export const UserAddressColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name",
    headerName: "اسم العنوان",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "governorate", // Changed from "city"
    headerName: "المحافظة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => getGovernorateName(params.value),
  },
  {
    field: "area", // Changed from "region"
    headerName: "المنطقة",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => getAreaName(params.value),
  },
  {
    field: "buildingNo",
    headerName: "رقم المنزل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "floorNo",
    headerName: "رقم الدور",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "addressSign",
    headerName: "علامة مميزة",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
];

export const DepartmentColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "photo",
    headerName: "الصورة",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={photosApi + params?.row?.photo}
            alt=""
            style={{ objectFit: "cover", width: "80%", height: "80%" }}
          />
        </div>
      );
    },
  },
  {
    field: "arname",
    headerName: "الاسم بالعربية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },
  {
    field: "enname",
    headerName: "الاسم بالانجليزية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return params?.row?.name?.en;
    },
  },
  {
    field: "ardescription",
    headerName: "الوصف بالعربية",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    flex: 1,

    renderCell: (params) => {
      return params?.row?.description?.ar;
    },
  },
  {
    field: "endescription",
    headerName: "الوصف بالانجليزية",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    flex: 1,

    renderCell: (params) => {
      return params?.row?.description?.en;
    },
  },
  {
    field: "services",
    headerName: "عدد الخدمات",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return params?.row?.services?.length || 0;
    },
  },
];

export const UserRatesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name",
    headerName: "اسم العامل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    flex: 1,
  },
  {
    field: "product_rate",
    headerName: "تقييم العامل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return (
        <Rating
          name="text-feedback"
          value={4}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
      );
    },
  },
];

export const WorkerColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "photo",
    headerName: "الصورة",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={photosApi + params?.row?.photo} alt="" />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phoneNumber",
    headerName: "رقم الهاتف",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span
        style={{
          direction: "ltr",
          unicodeBidi: "isolate",
        }}
      >
        {params?.row?.phoneNumber}
      </span>
    ),
  },
  {
    field: "alternativePhone",
    headerName: "رقم هاتف اخر",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "country",
    headerName: "الجنسية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "areas",
    headerName: "المناطق",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const areas = params?.row?.areas || [];
      return (
        <div style={{ textAlign: "center" }}>
          {areas.length > 0
            ? areas.map((area) => area?.name?.ar).join(" - ")
            : "لا توجد مناطق"}
        </div>
      );
    },
  },
  {
    field: "governorates",
    headerName: "المحافظات",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const governorates = params?.row?.governorates || [];
      return (
        <div style={{ textAlign: "center" }}>
          {governorates.length > 0
            ? governorates.map((gov) => gov?.name?.ar).join(" - ")
            : "لا توجد محافظات"}
        </div>
      );
    },
  },
  {
    field: "ratingAverage",
    headerName: "التقيم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "createdAt",
    headerName: "تاريخ و وقت التسجيل",
    minWidth: 220,
    headerAlign: "center",
    align: "center",

    renderCell: (params) =>
      moment(params?.row?.createdAt).locale("en").format("YYYY-MM-DD"),
  },
  {
    field: "bookingsCount",
    headerName: "عدد الطلبات",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "salary",
    headerName: "الراتب",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "category",
    headerName: "القسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.category?.name?.ar,
  },

  {
    field: "isAvailable",
    headerName: "متاح",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const isAvailable = params.value;
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              padding: "6px",
              borderRadius: "12px",
              fontSize: "14px",
              fontWeight: "500",

              color: isAvailable ? "#166534" : "#b91c1c",
            }}
          >
            {isAvailable ? "متاح" : "غير متاح"}
          </div>
        </div>
      );
    },
  },
];

export const WorkerRatesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "user",
    headerName: "اسم المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => params.row?.user?.name,
  },
  {
    field: "phoneNumber",
    headerName: "رقم المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => params.row?.user?.phoneNumber,
  },
  {
    field: "createdAt",
    headerName: "تاريخ التقييم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => moment(params?.row?.createdAt).format("YYYY/MM/DD"),
  },
  {
    field: "rating",
    headerName: "تقييم العامل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return (
        <Rating
          name="text-feedback"
          value={params?.row?.rating}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
      );
    },
  },
  // {
  //   field: "shop",
  //   headerName: "اسم المتجر",
  //   minWidth: 160,
  //   headerAlign: "center",
  //   align: "center",
  //
  //   flex: 1,
  // },
];

export const WorkerLogsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "loginTime",
    headerName: "وقت بدء العمل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const loginTime = moment(params?.row?.loginTime);
      const timeString = loginTime.format("hh:mm");
      const amPm = loginTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
  {
    field: "logoutTime",
    headerName: "وقت انتهاء العمل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.logoutTime);
      const timeString = logoutTime.format("hh:mm");
      const amPm = logoutTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
  {
    field: "totalHoursWorked",
    headerName: "ساعات العمل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },

  {
    field: "technical",
    headerName: "الحالة الان",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const isOnline = params.row.technician.isOnline;
      return (
        <span
          style={{
            color: isOnline ? "green" : "red",
            fontWeight: "bold",
          }}
        >
          {isOnline ? "متصل" : "غير متصل"}
        </span>
      );
    },
  },

  {
    field: "loginNotes",
    headerName: "ملاحظات تسجيل الدخول",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      if (params.row.loginChangedBy && params.row.loginChangedByType) {
        const isLoginSelf =
          params.row.loginChangedBy._id === params.row.technician._id;
        return isLoginSelf ? "بواسطة الفني نفسه" : "بواسطة الإدارة";
      }
      return "";
    },
  },
  {
    field: "logoutNotes",
    headerName: "ملاحظات تسجيل الخروج",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      if (params.row.logoutChangedBy && params.row.logoutChangedByType) {
        const isLogoutSelf =
          params.row.logoutChangedBy._id === params.row.technician._id;
        return isLogoutSelf ? "بواسطة الفني نفسه" : "بواسطة الإدارة";
      }
      return "";
    },
  },
];

export const QuestionColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "name",
    headerName: "اسم المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },

  {
    field: "phoneNumber",
    headerName: "رقم الجوال",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "الايميل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "type",
    headerName: "نوع الرسالة",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const typeMapping = {
        general_inquiry: "استفسار عام",
        technical_support: "دعم فني",
        suggestion: "اقتراح",
        complaint: "شكوى",
        other: "أخرى",
      };
      return typeMapping[params.value] || params.value;
    },
  },
  {
    field: "createdAt",
    headerName: "تاريخ الارسال",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (paramas) =>
      moment(paramas?.row?.createdAt).locale("en").format("YYYY/MM/DD hh:mm a"),
  },
];

export const PackagesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "namear",
    headerName: "اسم الباقة بالعربية",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },
  {
    field: "nameen",
    headerName: "اسم الباقة بالانجليزية",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.name?.en;
    },
  },
  {
    field: "price",
    headerName: "سعر الباقة",
    minWidth: 160,

    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`${params?.row?.price} ريال`}</span>;
    },
  },

  {
    field: "type",
    headerName: "نوع الباقة",
    minWidth: 160,

    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>{`${
          params?.row?.type === "annually" ? "سنوية" : "شهرية"
        } `}</span>
      );
    },
  },
  {
    field: "numberOfVisits",
    headerName: "عدد الزيارات المتاحه",
    minWidth: 160,

    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`${params?.row?.numberOfVisits} زيارة` || 0}</span>;
    },
  },
  {
    field: "dailyMaximum",
    headerName: "الحد اليومي لعدد الزيارات",
    minWidth: 160,

    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`${params?.row?.dailyMaximum} زيارة` || 0}</span>;
    },
  },
  {
    field: "createdAt",
    headerName: "تاريخ و وقت الانشاء",
    minWidth: 160,

    headerAlign: "center",
    align: "center",
    renderCell: (paramas) =>
      moment(paramas?.row?.createdAt).locale("en").format("YYYY-MM-DD"),
  },
];

export const ListsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "namear",
    headerName: "اسم القائمة بالعربية",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },
  {
    field: "nameen",
    headerName: "اسم القائمة بالانجليزية",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.name?.en;
    },
  },
  {
    field: "descar",
    headerName: "وصف القائمة بالعربية",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.description?.ar;
    },
  },
  {
    field: "descen",
    headerName: "وصف القائمة بالانجليزية",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.description?.en;
    },
  },
  {
    field: "packageNumber",
    headerName: "عدد الباقات",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.packages?.length;
    },
  },
];

export const CodeColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "code",
    headerName: "رمز كود الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "discount",
    headerName: "الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`${params.row.discount} %`}</span>;
    },
  },
  {
    field: "maxDiscount",
    headerName: "اقصي خصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`${params.row.maxDiscount} ريال`}</span>;
    },
  },

  {
    field: "maxUsage",
    headerName: "عدد مرات الاستخدام",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "usedNumbersOfUsing",
    headerName: "عدد من استخدمه",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`${params?.row?.usersUsed?.length} مرات`}</span>;
    },
  },
  {
    field: "creationDate",
    headerName: "تاريخ الانشاء",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (paramas) =>
      moment(paramas?.row?.createdAt).locale("en").format("YYYY-MM-DD"),
  },
  {
    field: "expireAt",
    headerName: "تاريخ الانتهاء",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (paramas) =>
      moment(paramas?.row?.expireAt).locale("en").format("YYYY-MM-DD"),
  },
];

export const AdminsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phoneNumber",
    headerName: "رقم الموبايل",
    minWidth: 110,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "البريد الالكتروني",
    minWidth: 140,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "createdAt",
    headerName: "تاريخ و وقت الانشاء",
    minWidth: 152,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.visitDate).locale("en");
      const timeString = logoutTime.format("YYYY/MM/DD hh:mm");
      const amPm = logoutTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
  {
    field: "credential",
    headerName: "الصلاحية",
    minWidth: 52,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.credential?.name,
  },
];
export const AdminsPermissionsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "name",
    headerName: "الاسم",
    minWidth: 84,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "numberOfOfficials",
    headerName: "عدد المسؤولين",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
  },
];

export const ViewProductsRatesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={AdminImg} alt="" />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "product_rate",
    headerName: "التقييم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    sortable: false,

    renderCell: (params) => {
      return (
        <Rating
          name="text-feedback"
          value={4}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
      );
    },
  },
];

export const ProductOrdersColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "orderNumber",
    headerName: "رقم الطلب",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "user",
    headerName: "اسم المستخدم",
    minWidth: 240,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => params?.row?.user?.name,
  },

  {
    field: "phoneNumber",
    headerName: "رقم جوال المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.user?.phoneNumber,
  },

  {
    field: "paymentMethod",
    headerName: "طريقة الدفع",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      params.row.isPackage ? (
        <span style={{ fontWeight: "bold", color: "#9e9e9e" }}>اشتراك</span>
      ) : (
        <span style={{ fontWeight: "bold", color: "#1976d2" }}>
          {params?.row?.paymentMethod}
        </span>
      ),
  },

  {
    field: "totalPrice",
    headerName: "المبلغ الاجمالي للفاتورة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) =>
      params.row.isPackage ? (
        <span style={{ fontWeight: "bold", color: "#9e9e9e" }}>اشتراك</span>
      ) : (
        <span style={{ fontWeight: "bold", color: "#1976d2" }}>
          {params?.row?.totalPrice?.totalPrice} ريال
        </span>
      ),
  },

  {
    field: "promoCodeDiscount",
    headerName: "قيمة الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      const discount = params?.row?.totalPrice?.promoCodeDiscount;

      if (discount === undefined || discount === null) {
        // Case 3: promoCodeDiscount doesn't exist (subscription)
        return (
          <span style={{ fontWeight: "bold", color: "#9e9e9e" }}>اشتراك</span>
        );
      } else if (discount === 0) {
        // Case 1: promoCodeDiscount exists but equals 0
        return (
          <span style={{ fontWeight: "bold", color: "#616161" }}>
            لا يوجد خصم (0 ريال)
          </span>
        );
      } else {
        // Case 2: promoCodeDiscount exists and is greater than 0
        return (
          <span style={{ fontWeight: "bold", color: "#1976d2" }}>
            {discount} ريال
          </span>
        );
      }
    },
  },

  {
    field: "services",
    headerName: "عدد الخدمات",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => params?.row?.services?.length,
  },

  {
    field: "technician",
    headerName: "العامل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => params?.row?.technician?.name,
  },

  {
    field: "category",
    headerName: "القسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.technician?.category?.name?.ar,
  },

  {
    field: "visitDate",
    headerName: "تاريخ و وقت الزيارة",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.visitDate).locale("en");
      const timeString = logoutTime.format("YYYY/MM/DD hh:mm");
      const amPm = logoutTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },

  {
    field: "status",
    headerName: "حالة الطلب",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      const statusArray = params?.row?.status;

      // Get the last status from the array
      if (!statusArray || statusArray.length === 0) {
        return "لا توجد حالة";
      }

      const lastStatus = statusArray[statusArray.length - 1];
      const statusValue = lastStatus.value;

      // Map status values to Arabic labels
      const statusLabels = {
        booked: "محجوز",
        onTheWay: "في الطريق",
        technicianArrived: "وصل الفني",
        inProgress: "قيد التنفيذ",
        completed: "مكتمل",
        canceled: "ملغي",
      };

      return statusLabels[statusValue] || statusValue;
    },
  },
];

export const SubscriptionsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "name",
    headerName: "اسم الباقة",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      params?.row?.package?.name?.ar || "اشتراك مخصص عن طريق المشرف",
  },
  {
    field: "price",
    headerName: "سعر الباقة الأصلي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span style={{ fontWeight: "bold", color: "#1976d2" }}>
        {params?.row?.package?.price || params?.row?.subscriptionDetails?.price}{" "}
        ريال
      </span>
    ),
  },
  {
    field: "discountValue",
    headerName: "قيمة الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const discount = params?.row?.discountValue;

      if (discount === undefined || discount === null || discount === 0) {
        return (
          <span style={{ fontWeight: "bold", color: "#9e9e9e" }}>
            لا يوجد خصم
          </span>
        );
      } else {
        return (
          <span style={{ fontWeight: "bold", color: "#4caf50" }}>
            {discount} ريال
          </span>
        );
      }
    },
  },
  {
    field: "priceAfterDiscount",
    headerName: "السعر بعد الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const originalPrice =
        params?.row?.package?.price ||
        params?.row?.subscriptionDetails?.price ||
        0;
      const discount = params?.row?.discountValue || 0;
      const finalPrice = originalPrice - discount;

      return (
        <span
          style={{
            fontWeight: "bold",
            color: discount > 0 ? "#2e7d32" : "#1976d2",
            fontSize: discount > 0 ? "1.05em" : "1em",
          }}
        >
          {finalPrice} ريال
        </span>
      );
    },
  },
  {
    field: "promoCode",
    headerName: "كود الخصم",
    minWidth: 140,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const promoCode = params?.row?.promoCode?.code;

      if (!promoCode) {
        return (
          <span style={{ color: "#9e9e9e", fontSize: "0.9em" }}>لا يوجد</span>
        );
      }

      return (
        <span
          style={{
            fontWeight: "bold",
            color: "#f57c00",
            backgroundColor: "#fff3e0",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {promoCode}
        </span>
      );
    },
  },
  {
    field: "paymentMethod",
    headerName: "طريقة الدفع",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const method =
        params?.row?.paymentMethod ||
        params?.row?.subscriptionDetails?.paymentMethod;
      const methodLabels = {
        creditcard: "بطاقة ائتمان",
        applepay: "Apple Pay",
        stcpay: "STC Pay",
        mada: "مدى",
      };

      return (
        <span style={{ fontWeight: "bold", color: "#1976d2" }}>
          {methodLabels[method] || method}
        </span>
      );
    },
  },
  {
    field: "user",
    headerName: "اسم صاحب الاشتراك",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.user?.name,
  },
  {
    field: "phoneNumber",
    headerName: "رقم جوال المشترك",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.user?.phoneNumber,
  },
  {
    field: "address",
    headerName: "العنوان",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {`${getNameById(params?.row?.address?.governorate)?.nameArabic} , ${
          getNameById(params?.row?.address?.area)?.nameArabic
        } , ${params?.row?.address?.street}`}
      </span>
    ),
  },
  {
    field: "numberOfVisits",
    headerName: "عدد الزيارات",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      params?.row?.package?.numberOfVisits ||
      params?.row?.subscriptionDetails?.numberOfVisits,
  },
  {
    field: "usedVisitsCount",
    headerName: "الزيارات المستخدمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const used = params?.row?.usedVisitsCount || 0;
      const total =
        params?.row?.package?.numberOfVisits ||
        params?.row?.subscriptionDetails?.numberOfVisits ||
        0;
      const remaining = total - used;

      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span style={{ fontWeight: "bold" }}>
            {used} من {total}
          </span>
          <span style={{ fontSize: "0.85em", color: "#666" }}>
            (متبقي: {remaining})
          </span>
        </div>
      );
    },
  },
  {
    field: "daysRemaining",
    headerName: "الأيام المتبقية",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    sortable: true,
    renderCell: (params) => {
      const today = moment();
      const expireDate = moment(params?.row?.expireAt);
      const daysLeft = expireDate.diff(today, "days");

      let color = "inherit";
      if (daysLeft <= 0) {
        color = "#f44336";
      } else if (daysLeft <= 7) {
        color = "#ff9800";
      } else if (daysLeft <= 30) {
        color = "#ffa726";
      } else {
        color = "#4caf50";
      }

      return (
        <div
          style={{
            color: color,
            fontWeight: daysLeft <= 30 ? "bold" : "normal",
          }}
        >
          {daysLeft > 0 ? `${daysLeft} يوم` : "منتهي"}
        </div>
      );
    },
  },
  {
    field: "createdAt",
    headerName: "تاريخ الاشتراك",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.createdAt).locale("ar");
      const timeString = logoutTime.format("YYYY/MM/DD hh:mm");
      const amPm = logoutTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
  {
    field: "expireAt",
    headerName: "تاريخ انتهاء الباقة",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      const expireTime = moment(params?.row?.expireAt).locale("ar");
      const timeString = expireTime.format("YYYY/MM/DD hh:mm");
      const amPm = expireTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
];

export const OrderColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "name",
    headerName: "اسم الخدمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },

  {
    field: "price",
    headerName: "سعر الخدمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return `${params?.row?.price} ريال`;
    },
  },
];

export const EditAddressColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "user",
    headerName: "اسم العميل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return params?.row?.user?.name;
    },
  },

  {
    field: "phone",
    headerName: "رقم العميل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return params?.row?.user?.phoneNumber;
    },
  },
  {
    field: "package",
    headerName: "اسم الباقة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return (
        params?.row?.subscription?.package?.name?.ar ||
        "اشتراك مخصص عن طريق المشرف"
      );
    },
  },
];

export const CancellationColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "user",
    headerName: "اسم العميل",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.user?.name;
    },
  },

  {
    field: "phone",
    headerName: "رقم العميل",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.user?.phoneNumber;
    },
  },
  {
    field: "amount",
    headerName: "قيمة الالغاء",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "reason",
    headerName: "حالة الالغاء",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{`قبل ${params?.row?.reason} ساعة`}</span>;
    },
  },
  {
    field: "createdAt",
    headerName: "تاريخ و وقت الالغاء",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.createdAt).locale("en");
      const timeString = logoutTime.format("YYYY-MM-DD hh:mm");
      const amPm = logoutTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
];

export const InspectionColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "user",
    headerName: "اسم العميل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.user?.name;
    },
  },

  {
    field: "phone",
    headerName: "رقم الجوال",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.user?.phoneNumber;
    },
  },
  {
    field: "address",
    headerName: "العنوان",
    minWidth: 320,
    headerAlign: "center",
    flex: 1,
    align: "center",
    renderCell: (params) => {
      const address = params.row.address;
      if (!address) return "";

      // Build address string in Arabic format
      const addressParts = [];

      if (address.name) addressParts.push(address.name);
      if (address.street) addressParts.push(address.street);
      if (address.region) addressParts.push(address.region);
      if (address.city) addressParts.push(address.city);
      if (address.addressSign) addressParts.push(`(${address.addressSign})`);

      return addressParts.join("، ");
    },
  },

  {
    field: "status",
    headerName: "حالة المعاينة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const statusMap = {
        pending: "قيد الانتظار",
        approved: "موافق عليه",
        failed: "مرفوض",
      };

      const status = params?.row?.status;
      return <span>{statusMap[status] || status}</span>;
    },
  },

  {
    field: "date",
    headerName: "تاريخ المعاينة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.date).locale("en");
      const timeString = logoutTime.format("YYYY-MM-DD ");

      return `${timeString} `;
    },
  },
];

export const ServiceColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "name",
    headerName: "اسم الخدمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },
  {
    field: "department",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.category?.name?.ar;
    },
  },
  {
    field: "price",
    headerName: "سعر الخدمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      return `${params?.row?.price} ريال`;
    },
  },
];

export const RecommendedServicesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "name",
    headerName: "اسم الخدمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },
  {
    field: "description",
    headerName: "الوصف",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.description?.ar;
    },
  },
  {
    field: "department",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.category?.name?.ar;
    },
  },
  {
    field: "votersCount",
    headerName: "عدد الأصوات",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return params?.row?.votersCount || 0;
    },
  },
  {
    field: "status",
    headerName: "الحالة",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      const status = params?.row?.status;
      const statusMap = {
        pending: "قيد الانتظار",
        approved: "موافق عليها",
        rejected: "مرفوضة",
        reviewing: "قيد المراجعة",
      };
      return statusMap[status] || status;
    },
  },
];

export const PartsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={photosApi + params?.row?.photo} alt="" />
        </div>
      );
    },
  },

  {
    field: "name",
    headerName: "اسم القطعة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.name?.ar;
    },
  },
  {
    field: "description",
    headerName: "وصف القطعة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.description?.ar;
    },
  },
  {
    field: "department",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params?.row?.category?.name?.ar;
    },
  },
  {
    field: "price",
    headerName: "سعر القطعة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      return `${params?.row?.price} ريال`;
    },
  },
];

export const RatingColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "name",
    headerName: "اسم العميل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.user?.name;
    },
  },
  {
    field: "department",
    headerName: "جوال العميل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params?.row?.user?.phoneNumber;
    },
  },
  {
    field: "createdAt",
    headerName: "تاريخ الانشاء",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (paramas) => {
      return moment(paramas?.row?.createdAt).locale("en").format("YYYY-MM-DD");
    },
  },
  {
    field: "comment",
    headerName: "التعليق",
    minWidth: 320,
    headerAlign: "center",
    align: "center",
    sortable: false,
    flex: 1,
  },
];

export const AdminsData = [
  {
    id: "1",
    name: "eyad adel",
    phone: "+201028252809",
    email: "username1@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "مدير",
    last_login: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "20",
    status: true,
  },
  {
    id: "2",
    name: "eyad adel",
    phone: "+201028252807",
    email: "username2@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "سكرتير",
    last_login: "22/03/2024- 08:30 PM",
    method: "فيس بوك",
    orders: "17",
    status: true,
  },
  {
    id: "3",
    name: "eyad adel",
    phone: "+201028252808",
    email: "username3@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "عامل",
    last_login: "22/03/2024- 08:30 PM",
    method: "تويتر",
    orders: "15",
    status: false,
  },
  {
    id: "4",
    name: "eyad adel",
    phone: "+201028252806",
    email: "username4@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "مندوب",
    last_login: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "3",
    status: true,
  },
  {
    id: "5",
    name: "eyad adel",
    phone: "+201028252805",
    email: "username5@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "مبرمج",
    last_login: "22/03/2024- 08:30 PM",
    method: "ايميل",
    orders: "0",
    status: false,
  },
];

export const AdminsPermissionsData = [
  {
    id: "1",
    name: "مدير",
    count: "17",
    status: true,
  },
  {
    id: "2",
    name: "غفير",
    count: "27",
    status: true,
  },
  {
    id: "3",
    name: "امير",
    count: "1",
    status: true,
  },
  {
    id: "4",
    name: "عويل",
    count: "7",
    status: true,
  },
];

export const AdminPermissions = [
  {
    id: 1,
    name: "لوحة التحكم",
    subPermissions: [
      {
        id: 1,
        name: "صفحة لوحة التحكم",
      },
      { id: 2, name: "عدد المستخدمين" },
      { id: 3, name: "عدد الاقسام" },
      { id: 4, name: "عدد الخدمات" },
      { id: 5, name: "عدد الاشتراكات" },
      { id: 6, name: "عدد العمال" },
      { id: 7, name: "عدد الطلبات" },
      { id: 8, name: "الايرادات" },
      { id: 9, name: "حالة الطلبات شهريا" },
      { id: 10, name: "المستخدمين المنضمين الجدد" },
      {
        id: 1001,
        name: "عدد الحجوزات المكتملة",
      },
      {
        id: 1002,
        name: " عدد طلبات الاسترداد قيد الانتظار",
      },
      {
        id: 1003,
        name: "عدد طلبات الاسترداد",
      },
      {
        id: 1004,
        name: "عدد طلبات الدعم الفني",
      },
      {
        id: 1005,
        name: "عدد طلبات تغيير عنوان الاشتراك",
      },
      {
        id: 1006,
        name: "عدد طلبات المعاينة",
      },
    ],
  },
  {
    id: 11,
    name: "المسئولين الفرعيين",
    subPermissions: [
      { id: 11, name: "صفحة المسئولين الفرعيين" },
      { id: 12, name: "اضافة" },
      { id: 13, name: "رؤية" },
      { id: 14, name: "تعديل" },
      { id: 15, name: "حذف" },
      { id: 16, name: "تفعيل" },
    ],
  },
  {
    id: 17,
    name: "الصلاحيات",
    subPermissions: [
      { id: 17, name: "صفحة الصلاحيات" },
      { id: 18, name: "تفعيل" },
      { id: 19, name: "تعديل" },
      { id: 20, name: "اضافة" },
      { id: 21, name: "حذف" },
      { id: 22, name: "رؤية" },
    ],
  },
  {
    id: 23,
    name: "المستخدمين",
    subPermissions: [
      { id: 23, name: "صفحة المستخدمين" },
      { id: 24, name: "رؤية جميع المستخدمين" },
      { id: 25, name: "تفعيل" },
      { id: 26, name: "حذف" },
      { id: 27, name: "تغيير الباسورد" },
      { id: 28, name: "رؤية مستخدم" },
    ],
  },
  {
    id: 29,
    name: "العمال",
    subPermissions: [
      { id: 29, name: "صفحة العمال" },
      { id: 30, name: "اضافة عامل" },
      { id: 31, name: "رؤية جميع العمال" },
      { id: 32, name: "تغيير حالة العامل" },
      { id: 33, name: "تغيير كلمة مرور العامل" },
      { id: 34, name: "تعديل بيانات العامل" },
      { id: 35, name: "رؤية عامل" },
      { id: 36, name: "حذف عامل" },
      { id: 37, name: "الحضور والانصراف للعامل" },
    ],
  },
  {
    id: 38,
    name: "الاقسام",
    subPermissions: [
      { id: 38, name: "صفحة الاقسام" },
      { id: 39, name: "اضافة قسم" },
      { id: 40, name: "رؤية كل الاقسام" },
      { id: 41, name: "تفعيل القسم" },
      { id: 42, name: "تعديل" },
      { id: 43, name: "حذف" },
    ],
  },
  {
    id: 44,
    name: "الخدمات",
    subPermissions: [
      { id: 44, name: "صفحة الخدمات" },
      { id: 45, name: "اضافة خدمة" },
      { id: 46, name: "رؤية جميع الخدمات" },
      { id: 47, name: "تفعيل" },
      { id: 48, name: "تعديل" },
      { id: 49, name: "حذف" },
    ],
  },
  {
    id: 110,
    name: "الخدمات المقترحة",
    subPermissions: [
      { id: 110, name: "صفحة الخدمات المقترحه" },
      { id: 111, name: "رؤية الخدمات المقترحه" },
      { id: 112, name: "تغير الحالة المقترحه" },
      { id: 113, name: "حذف الخدمات المقترحه" },
    ],
  },
  {
    id: 118,
    name: "قطع الغيار",
    subPermissions: [
      { id: 118, name: "صفحة قطع الغيار" },
      { id: 119, name: "إضافة قطعة غيار" },
      { id: 120, name: "رؤية جميع قطع الغيار" },
      { id: 122, name: "تعديل قطعة غيار" },
      { id: 123, name: "حذف قطعة غيار" },
      { id: 124, name: "تفعيل حالة قطعة غيار" },
    ],
  },
  {
    id: 50,
    name: "الباقات",
    subPermissions: [
      { id: 50, name: "صفحة الباقات" },
      { id: 51, name: "اضافة باقة" },
      { id: 52, name: "رؤية" },
      { id: 53, name: "تفعيل" },
      { id: 54, name: "تعديل" },
      { id: 55, name: "حذف" },
    ],
  },
  {
    id: 56,
    name: "القوائم",
    subPermissions: [
      { id: 56, name: "صفحة القوائم" },
      { id: 57, name: "اضافة" },
      { id: 58, name: "رؤية" },
      { id: 59, name: "تفعيل" },
      { id: 60, name: "تعديل" },
      { id: 61, name: "حذف" },
    ],
  },
  {
    id: 62,
    name: "الطلبات",
    subPermissions: [
      { id: 62, name: "صفحة الطلبات" },
      { id: 63, name: "رؤية طلبات" },
      { id: 64, name: "رؤية طلب" },
      {
        id: 67,
        name: "رؤية طلبات مستخدم",
      },
    ],
  },
  {
    id: 65,
    name: "الاشتراكات",
    subPermissions: [
      { id: 65, name: "صفحة الاشتراكات" },
      { id: 128, name: "رؤية" }, //128
      { id: 129, name: "تفعيل" }, //129
    ],
  },
  {
    id: 130, //68 69
    name: "طلبات المعاينة",
    subPermissions: [
      { id: 130, name: "صفحة طلبات المعاينة" },
      { id: 131, name: "رؤية كل الطلبات" },
      { id: 70, name: "حذف الطلب" },
      { id: 71, name: "الموافقة علي الطلب" },
    ],
  },
  {
    id: 72,
    name: "اكواد الخصم",
    subPermissions: [
      { id: 72, name: "صفحة اكواد الخصم" },
      { id: 73, name: "اضافة" },
      { id: 74, name: "رؤية" },
      { id: 75, name: "تفعيل" },
      { id: 76, name: "حذف" },
      { id: 77, name: "تعديل" },
    ],
  },
  {
    id: 78,
    name: "الاشعارات",
    subPermissions: [
      { id: 78, name: "صفحة الاشعارات الاشعارات" },
      { id: 79, name: "اضافة" },
      { id: 80, name: "رؤية" },
      { id: 81, name: "رؤية اشعار" },
    ],
  },
  // ابدء من هنا
  {
    id: 82,
    name: "الرسائل",
    subPermissions: [
      { id: 82, name: "صفحة الرسائل" },
      { id: 83, name: "رصيد الرسائل" },
      { id: 84, name: "اضافة" },
      { id: 85, name: "رؤية" },
    ],
  },
  {
    id: 86,
    name: "اراء العملاء",
    subPermissions: [
      { id: 86, name: " صفحة اراء العملاء" },
      { id: 87, name: "رؤية" },
      { id: 88, name: "تفعيل" },
      { id: 89, name: "حذف" },
    ],
  },
  {
    id: 90,
    name: "الدعم الفني",
    subPermissions: [
      { id: 90, name: "صفحة الدعم الفني" },
      { id: 91, name: "رؤية جميع الطلبات" },
      { id: 92, name: "تعديل طلب دعم بملاحظات" },
    ],
  },
  {
    id: 93,
    name: "اعدادت النظام",
    subPermissions: [
      { id: 93, name: "صفحة اعدادت النظام" },
      { id: 94, name: "رؤية الاعدادات العامة" },
      { id: 95, name: "تعديل الاعدادات العامة" },
      { id: 96, name: "تعديل روابط التواصل" },
      { id: 97, name: "رؤية روابط تواصل معانا" },
      { id: 98, name: "اضافة شرط جديد" },
      { id: 99, name: "رؤية كل الشروط" },
      { id: 100, name: "تعديل شرط" },
      { id: 101, name: "حذف شرط" },
      { id: 132, name: "رؤية المناطق" },
      { id: 133, name: "اضافة وتعديل مناطق" },
      { id: 135, name: "تحليلات المناطق" },
      {
        id: 136,
        name: " الأكثر استخداماً",
      },
      {
        id: 137,
        name: "طلبات التوسع",
      },
    ],
  },
  // لحد هنا
  {
    id: 102,
    name: "طلبات تغيير عنوان الاشتراك",
    subPermissions: [
      { id: 102, name: "صفحة تغيير عنوان الاشتراك" },
      { id: 103, name: "روية كل الطلبات" },
      { id: 104, name: "الموافقة او الرفض علي الطلب" },
    ],
  },
  {
    id: 105,
    name: "طلبات الالغاء",
    subPermissions: [
      { id: 105, name: "صفحة طلبات الالغاء" },
      { id: 106, name: "رؤية كل الطلبات الالغاء" },
      { id: 107, name: "ارجاع المبلغ للعميل" },
    ],
  },
];

export const NotificationsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "photo",
    headerName: "الصورة",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={photosApi + params?.row?.photo} alt="" />
        </div>
      );
    },
  },
  {
    field: "arName",
    headerName: "العنوان بالعربي",
    minWidth: 160,
    headerAlign: "center",
    flex: 1,
    align: "center",
    sortable: false,
    renderCell: (params) => params?.row?.title?.ar,
  },
  {
    field: "enName",
    headerName: "العنوان بالانجليزية",
    minWidth: 160,
    headerAlign: "center",
    flex: 1,
    align: "center",
    sortable: false,
    renderCell: (params) => params?.row?.title?.en,
  },
  {
    field: "arText",
    headerName: "النص بالعربي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    sortable: false,
    renderCell: (params) => params?.row?.text?.ar,
  },
  {
    field: "enText",
    headerName: "النص بالانجليزية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    sortable: false,
    flex: 1,
    renderCell: (params) => params?.row?.text?.en,
  },
  {
    field: "senderType",
    headerName: "المستلمين",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "createdAt",
    headerName: "تاريخ الانشاء",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const logoutTime = moment(params?.row?.createdAt).locale("en");
      const timeString = logoutTime.format("YYYY-MM-DD hh:mm");
      const amPm = logoutTime.hour() < 12 ? "صباحاً" : "مساءً";
      return `${timeString} ${amPm}`;
    },
  },
];

export const MessagesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "message",
    headerName: "نص الرسالة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "enText",
    headerName: "عدد الاحرف",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    renderCell: (paramas) => paramas?.row?.message?.length,
  },
  {
    field: "receiverType",
    headerName: "المستلمين",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    type: "singleSelect",
    valueOptions: [
      "all",
      "users",
      "technicians",
      "specific-users",
      "specific-technicians",
    ],
    renderCell: (params) => {
      const receiverTypeMap = {
        all: "الجميع",
        users: "المستخدمين",
        technicians: "الفنيين",
        "specific-users": "مستخدمين محددين",
        "specific-technicians": "فنيين محددين",
      };

      return receiverTypeMap[params?.row?.receiverType] || params.value;
    },
  },
  {
    field: "creationDate",
    headerName: "تاريخ الارسال",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (paramas) =>
      moment(paramas?.row?.createdAt).locale("en").format("YYYY/MM/DD hh:mm a"),
  },
];

export const CreateNotificationsColumns = [
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={AdminImg} alt="" />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 90,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 110,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const SidebarList = [
  {
    label: "لوحة التحكم",
    path: "/",
    icon: <HomeIcon className="icon" />,
    id: 1,
  },
  {
    label: "المسؤلين الفرعين",
    path: "/admins",
    icon: <SubAdminIcon className="icon" />,
    id: 11,
  },
  {
    label: "المستخدمين",
    path: "/users",
    icon: <UsersIcon className="icon" />,
    id: 23,
  },
  {
    label: "العمال",
    path: "/workers",
    icon: <EngineeringOutlinedIcon className="icon" />,
    id: 29,
  },
  {
    label: "الاقسام",
    path: "/departments",
    icon: <DepartmentsIcon className="icon" />,
    id: 38,
  },
  {
    label: "الخدمات",
    path: "/services",
    icon: <ProductsIcon className="icon" />,
    id: 44,
  },
  {
    label: "قطع الغيار",
    path: "/parts",
    icon: <SparePartsIcon className="icon" />,
    id: 118,
  },
  {
    label: "الباقات",
    path: "/packages",
    icon: <ProductsOrdersIcon className="icon" />,
    id: 50,
  },
  {
    label: "الطلبات",
    path: "/orders",
    icon: (
      <NotificationBadge notificationKey="orders">
        <TableViewOutlinedIcon className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "orders",
    id: 62,
  },
  {
    label: "الاشتراكات",
    path: "/subscriptions",
    icon: (
      <NotificationBadge notificationKey="subscriptions">
        <CardMembershipOutlinedIcon className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "subscriptions",
    id: 65,
  },
  {
    label: "طلبات تعديل العنوان",
    path: "/request-edit-address",
    icon: (
      <NotificationBadge notificationKey="changeAddressRequests">
        <EditLocationOutlinedIcon className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "changeAddressRequests",
    id: 102,
  },
  {
    label: "طلبات الالغاء",
    path: "/cancellation-requests",
    icon: (
      <NotificationBadge notificationKey="cancellationRequests">
        <CancellationRequests className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "cancellationRequests",
    id: 105,
  },
  {
    label: "طلبات المعاينة",
    path: "/inspection-requests",
    icon: (
      <NotificationBadge notificationKey="previewRequests">
        <InterpreterModeOutlinedIcon className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "previewRequests",
    id: 130,
  },

  {
    label: "اكواد الخصم",
    path: "/discount-codes",
    icon: <DiscountIcon className="icon" />,
    id: 72,
  },
  {
    label: "الاشعارات",
    path: "/notifications",
    icon: <NotificationsIcon className="icon" />,
    id: 78,
  },
  {
    label: "الرسائل النصية",
    path: "/messages",
    icon: (
      <NotificationBadge notificationKey="messages">
        <MessagesIcon className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "messages",
    id: 82,
  },
  {
    label: "اراء العملاء",
    path: "/ratings",
    icon: <ThumbsUpDownOutlinedIcon className="icon" />,
    id: 86,
  },
  {
    label: "تواصل معنا",
    path: "/support",
    icon: (
      <NotificationBadge notificationKey="supportQuestions">
        <SupportIcon className="icon" />
      </NotificationBadge>
    ),
    hasNotification: true,
    notificationKey: "supportQuestions",
    id: 90,
  },
  {
    label: "اعدادات النظام",
    path: "/settings",
    icon: <SettingsIcon className="icon" />,
    id: 93,
  },
];

export const DummyData = [
  {
    id: "1",
    name: "eyad adel",
    phone: "+201028252809",
    email: "username1@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "20",
    status: true,
  },
  {
    id: "2",
    name: "eyad adel",
    phone: "+201028252807",
    email: "username2@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "فيس بوك",
    orders: "17",
    status: true,
  },
  {
    id: "3",
    name: "eyad adel",
    phone: "+201028252808",
    email: "username3@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "تويتر",
    orders: "15",
    status: false,
  },
  {
    id: "4",
    name: "eyad adel",
    phone: "+201028252806",
    email: "username4@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "3",
    status: true,
  },
  {
    id: "5",
    name: "eyad adel",
    phone: "+201028252805",
    email: "username5@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "ايميل",
    orders: "0",
    status: false,
  },
];

export const HomeDummy = {
  reservationsStatus: [
    {
      month: "يناير",
      طلب: 13,
    },
    {
      month: "فبراير",
      طلب: 57,
    },
    {
      month: "مارس",
      طلب: 50,
    },
    {
      month: "أبريل",
      طلب: 112,
    },
    {
      month: "مايو",
      طلب: 99,
    },
    {
      month: "يونيو",
      طلب: 12,
    },
    {
      month: "يوليو",
      طلب: 51,
    },
    {
      month: "أغسطس",
      طلب: 67,
    },
    {
      month: "سبتمبر",
      طلب: 31,
    },
    {
      month: "أكتوبر",
      طلب: 70,
    },
    {
      month: "نوفمبر",
      طلب: 80,
    },
    {
      month: "ديسمبر",
      طلب: 111,
    },
  ],
};

export const countriesInArabic = [
  "أفغانستان",
  "ألبانيا",
  "الجزائر",
  "أندورا",
  "أنغولا",
  "الأرجنتين",
  "أرمينيا",
  "أستراليا",
  "النمسا",
  "أذربيجان",
  "البحرين",
  "بنغلاديش",
  "بيلاروسيا",
  "بلجيكا",
  "بليز",
  "بنين",
  "بوتان",
  "بوليفيا",
  "البوسنة والهرسك",
  "بوتسوانا",
  "البرازيل",
  "بروناي",
  "بلغاريا",
  "بوركينا فاسو",
  "بوروندي",
  "كمبوديا",
  "الكاميرون",
  "كندا",
  "جمهورية أفريقيا الوسطى",
  "تشاد",
  "تشيلي",
  "الصين",
  "كولومبيا",
  "جزر القمر",
  "الكونغو",
  "كوستاريكا",
  "كرواتيا",
  "كوبا",
  "قبرص",
  "التشيك",
  "الدانمارك",
  "جيبوتي",
  "دومينيكا",
  "جمهورية الدومينيكان",
  "الإكوادور",
  "مصر",
  "السلفادور",
  "غينيا الاستوائية",
  "إريتريا",
  "إستونيا",
  "إسواتيني",
  "إثيوبيا",
  "فيجي",
  "فنلندا",
  "فرنسا",
  "الغابون",
  "غامبيا",
  "جورجيا",
  "ألمانيا",
  "غانا",
  "اليونان",
  "غرينادا",
  "غواتيمالا",
  "غينيا",
  "غينيا بيساو",
  "غيانا",
  "هايتي",
  "هندوراس",
  "المجر",
  "آيسلندا",
  "الهند",
  "إندونيسيا",
  "إيران",
  "العراق",
  "أيرلندا",
  "إيطاليا",
  "ساحل العاج",
  "جامايكا",
  "اليابان",
  "الأردن",
  "كازاخستان",
  "كينيا",
  "كيريباتي",
  "الكويت",
  "قرغيزستان",
  "لاوس",
  "لاتفيا",
  "لبنان",
  "ليسوتو",
  "ليبيريا",
  "ليبيا",
  "ليختنشتاين",
  "ليتوانيا",
  "لوكسمبورغ",
  "مدغشقر",
  "مالاوي",
  "ماليزيا",
  "المالديف",
  "مالي",
  "مالطا",
  "جزر مارشال",
  "موريتانيا",
  "موريشيوس",
  "المكسيك",
  "ميكرونيزيا",
  "مولدوفا",
  "موناكو",
  "منغوليا",
  "الجبل الأسود",
  "المغرب",
  "موزمبيق",
  "ميانمار",
  "ناميبيا",
  "ناورو",
  "نيبال",
  "هولندا",
  "نيوزيلندا",
  "نيكاراغوا",
  "النيجر",
  "نيجيريا",
  "كوريا الشمالية",
  "مقدونيا الشمالية",
  "النرويج",
  "عمان",
  "باكستان",
  "بالاو",
  "فلسطين",
  "بنما",
  "بابوا غينيا الجديدة",
  "باراغواي",
  "بيرو",
  "الفلبين",
  "بولندا",
  "البرتغال",
  "قطر",
  "رومانيا",
  "روسيا",
  "رواندا",
  "سانت كيتس ونيفيس",
  "سانت لوسيا",
  "سانت فنسنت والغرينادين",
  "ساموا",
  "سان مارينو",
  "ساو تومي وبرينسيب",
  "السعودية",
  "السنغال",
  "صربيا",
  "سيشيل",
  "سيراليون",
  "سنغافورة",
  "سلوفاكيا",
  "سلوفينيا",
  "جزر سليمان",
  "الصومال",
  "جنوب أفريقيا",
  "كوريا الجنوبية",
  "جنوب السودان",
  "إسبانيا",
  "سريلانكا",
  "السودان",
  "سورينام",
  "السويد",
  "سويسرا",
  "سوريا",
  "طاجيكستان",
  "تنزانيا",
  "تايلاند",
  "تيمور الشرقية",
  "توجو",
  "تونغا",
  "ترينيداد وتوباغو",
  "تونس",
  "تركيا",
  "تركمانستان",
  "توفالو",
  "أوغندا",
  "أوكرانيا",
  "الإمارات العربية المتحدة",
  "المملكة المتحدة",
  "الولايات المتحدة",
  "أوروغواي",
  "أوزبكستان",
  "فانواتو",
  "فنزويلا",
  "فيتنام",
  "اليمن",
  "زامبيا",
  "زيمبابوي",
];

export const photosApi = "https://api.houfalmanazel.com/";

// Columns for the DataGrid
export const NotificationMessagesUsersColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "name",
    headerName: "اسم المستخدم",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "phoneNumber",
    headerName: "رقم الهاتف",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
];

export const NotificationMessagesTechniciansColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "name",
    headerName: "اسم الفني",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "phoneNumber",
    headerName: "رقم الهاتف",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
];

export const weekDays = [
  "سبت",
  "أحد",
  "اثنين",
  "ثلاثاء",
  "أربعاء",
  "خميس",
  "جمعة",
];
export const monthNames = [
  "يناير",
  "فبراير",
  "مارس",
  "إبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];

export const SaudiArabiaAreas = [
  {
    areaId: "SA-01",
    areaNameArabic: "الرياض",
    areaNameEnglish: "Riyadh",
    coordinates: [24.65, 46.7],
    governorates: [
      {
        id: "SA-01-01",
        nameArabic: "الدرعية",
        nameEnglish: "Ad Diriyah",
        coordinates: [24.744028, 46.576934],
      },
      {
        id: "SA-01-02",
        nameArabic: "الخرج",
        nameEnglish: "Al Kharj",
        coordinates: [24.15559, 47.33466],
      },
      {
        id: "SA-01-03",
        nameArabic: "الدوادمي",
        nameEnglish: "Ad Dawadmi",
        coordinates: [24.507325, 44.392323],
      },
      {
        id: "SA-01-04",
        nameArabic: "رماح",
        nameEnglish: "Rumah",
        coordinates: [25.9117, 46.2887],
      },
      {
        id: "SA-01-05",
        nameArabic: "شقراء",
        nameEnglish: "Shaqra",
        coordinates: [25.2582, 45.262],
      },
      {
        id: "SA-01-06",
        nameArabic: "الزلفي",
        nameEnglish: "Al Zulfi",
        coordinates: [26.2994, 44.815],
      },
      {
        id: "SA-01-07",
        nameArabic: "المزاحمية",
        nameEnglish: "Al Muzahimiyah",
        coordinates: [24.4709, 46.2622],
      },
      {
        id: "SA-01-08",
        nameArabic: "عفيف",
        nameEnglish: "Afif",
        coordinates: [23.906, 42.917],
      },
      {
        id: "SA-01-09",
        nameArabic: "حريملاء",
        nameEnglish: "Huraymila",
        coordinates: [25.1109, 46.1022],
      },
      {
        id: "SA-01-10",
        nameArabic: "المجمعة",
        nameEnglish: "Al Majma'ah",
        coordinates: [25.9056, 45.3619],
      },
      {
        id: "SA-01-11",
        nameArabic: "القويعية",
        nameEnglish: "Al Quway'iyah",
        coordinates: [24.0689, 45.2875],
      },
      {
        id: "SA-01-12",
        nameArabic: "وادي الدواسر",
        nameEnglish: "Wadi Al Dawasir",
        coordinates: [20.5028, 44.8544],
      },
      {
        id: "SA-01-13",
        nameArabic: "الأفلاج",
        nameEnglish: "Al Aflaj",
        coordinates: [22.1039, 46.6939],
      },
      {
        id: "SA-01-14",
        nameArabic: "حوطة بني تميم",
        nameEnglish: "Hawtat Bani Tamim",
        coordinates: [23.5167, 46.85],
      },
      {
        id: "SA-01-15",
        nameArabic: "السليل",
        nameEnglish: "As Sulayyil",
        coordinates: [20.4625, 45.5778],
      },
      {
        id: "SA-01-16",
        nameArabic: "ضرماء",
        nameEnglish: "Dhurma",
        coordinates: [24.645, 46.28],
      },
      {
        id: "SA-01-17",
        nameArabic: "ثادق",
        nameEnglish: "Thadiq",
        coordinates: [25.2928, 45.8731],
      },
      {
        id: "SA-01-18",
        nameArabic: "الحريق",
        nameEnglish: "Al Hariq",
        coordinates: [23.9186, 46.9078],
      },
      {
        id: "SA-01-19",
        nameArabic: "الغاط",
        nameEnglish: "Al Ghat",
        coordinates: [26.0317, 45.03],
      },
      {
        id: "SA-01-20",
        nameArabic: "مرات",
        nameEnglish: "Marat",
        coordinates: [25.0442, 42.2469],
      },
    ],
  },
  {
    areaId: "SA-02",
    areaNameArabic: "مكة المكرمة",
    areaNameEnglish: "Makkah",
    coordinates: [21.42251, 39.826168],
    governorates: [
      {
        id: "SA-02-01",
        nameArabic: "مكة المكرمة",
        nameEnglish: "Makkah",
        coordinates: [21.42251, 39.826168],
      },
      {
        id: "SA-02-02",
        nameArabic: "جدة",
        nameEnglish: "Jeddah",
        coordinates: [21.485811, 39.192505],
      },
      {
        id: "SA-02-03",
        nameArabic: "الطائف",
        nameEnglish: "Taif",
        coordinates: [21.285406, 40.536904],
      },
      {
        id: "SA-02-04",
        nameArabic: "رابغ",
        nameEnglish: "Rabigh",
        coordinates: [22.7983, 39.0349],
      },
      {
        id: "SA-02-05",
        nameArabic: "الكامل",
        nameEnglish: "Al Kamil",
        coordinates: [22.1149, 39.9519],
      },
      {
        id: "SA-02-06",
        nameArabic: "القنفذة",
        nameEnglish: "Al Qunfudhah",
        coordinates: [19.1264, 41.0789],
      },
      {
        id: "SA-02-07",
        nameArabic: "الخرمة",
        nameEnglish: "Al Khurma",
        coordinates: [21.9172, 42.0289],
      },
      {
        id: "SA-02-08",
        nameArabic: "الليث",
        nameEnglish: "Al Lith",
        coordinates: [20.1578, 40.2678],
      },
      {
        id: "SA-02-09",
        nameArabic: "خليص",
        nameEnglish: "Khulais",
        coordinates: [22.3542, 39.2119],
      },
      {
        id: "SA-02-10",
        nameArabic: "رنية",
        nameEnglish: "Ranyah",
        coordinates: [21.2728, 42.825],
      },
      {
        id: "SA-02-11",
        nameArabic: "تربة",
        nameEnglish: "Turbah",
        coordinates: [21.2161, 41.6297],
      },
      {
        id: "SA-02-12",
        nameArabic: "الجموم",
        nameEnglish: "Al Jumum",
        coordinates: [21.6089, 39.7],
      },
      {
        id: "SA-02-13",
        nameArabic: "أضم",
        nameEnglish: "Adham",
        coordinates: [19.9297, 41.6869],
      },
      {
        id: "SA-02-14",
        nameArabic: "المويه",
        nameEnglish: "Al Muwayh",
        coordinates: [22.4358, 41.7583],
      },
      {
        id: "SA-02-15",
        nameArabic: "ميسان",
        nameEnglish: "Maysan",
        coordinates: [20.3383, 41.8139],
      },
      {
        id: "SA-02-16",
        nameArabic: "أرينبة",
        nameEnglish: "Arinbah",
        coordinates: [21.7067, 40.0],
      },
      {
        id: "SA-02-17",
        nameArabic: "العرضيات",
        nameEnglish: "Al Ardiyat",
        coordinates: [19.9786, 41.6542],
      },
    ],
  },
  {
    areaId: "SA-03",
    areaNameArabic: "المدينة المنورة",
    areaNameEnglish: "Madinah",
    coordinates: [24.470901, 39.612236],
    governorates: [
      {
        id: "SA-03-01",
        nameArabic: "المدينة المنورة",
        nameEnglish: "Madinah",
        coordinates: [24.470901, 39.612236],
      },
      {
        id: "SA-03-02",
        nameArabic: "ينبع",
        nameEnglish: "Yanbu",
        coordinates: [24.0908, 38.0618],
      },
      {
        id: "SA-03-03",
        nameArabic: "العلا",
        nameEnglish: "AlUla",
        coordinates: [26.6167, 37.9167],
      },
      {
        id: "SA-03-04",
        nameArabic: "بدر",
        nameEnglish: "Badr",
        coordinates: [23.7828, 38.7905],
      },
      {
        id: "SA-03-05",
        nameArabic: "الحناكية",
        nameEnglish: "Al Hinakiyah",
        coordinates: [24.886, 40.541],
      },
      {
        id: "SA-03-06",
        nameArabic: "ينبع البحر",
        nameEnglish: "Yanbu Al Bahr",
        coordinates: [24.084, 38.056],
      },
      {
        id: "SA-03-07",
        nameArabic: "مهد الذهب",
        nameEnglish: "Mahd Al Dhahab",
        coordinates: [23.5108, 40.8667],
      },
      {
        id: "SA-03-08",
        nameArabic: "خيبر",
        nameEnglish: "Khaybar",
        coordinates: [25.7014, 39.2922],
      },
      {
        id: "SA-03-09",
        nameArabic: "وادي الفرع",
        nameEnglish: "Wadi Al Fara'",
        coordinates: [24.6944, 38.4083],
      },
    ],
  },
  {
    areaId: "SA-04",
    areaNameArabic: "القصيم",
    areaNameEnglish: "Al Qassim",
    coordinates: [26.326, 43.975],
    governorates: [
      {
        id: "SA-04-01",
        nameArabic: "بريدة",
        nameEnglish: "Buraidah",
        coordinates: [26.3592, 43.9818],
      },
      {
        id: "SA-04-02",
        nameArabic: "عنيزة",
        nameEnglish: "Unaizah",
        coordinates: [26.0844, 43.9928],
      },
      {
        id: "SA-04-03",
        nameArabic: "النبهانية",
        nameEnglish: "Al Nabhaniyah",
        coordinates: [25.7317, 43.4169],
      },
      {
        id: "SA-04-04",
        nameArabic: "الرس",
        nameEnglish: "Ar Rass",
        coordinates: [25.8694, 43.4973],
      },
      {
        id: "SA-04-05",
        nameArabic: "المذنب",
        nameEnglish: "Al Midhnab",
        coordinates: [25.8661, 44.2142],
      },
      {
        id: "SA-04-06",
        nameArabic: "البكيرية",
        nameEnglish: "Al Bukayriyah",
        coordinates: [26.1369, 43.6558],
      },
      {
        id: "SA-04-07",
        nameArabic: "البدائع",
        nameEnglish: "Al Badai'",
        coordinates: [25.9358, 43.7142],
      },
      {
        id: "SA-04-08",
        nameArabic: "عيون الجواء",
        nameEnglish: "Uyun Al Jiwa",
        coordinates: [26.3967, 44.325],
      },
      {
        id: "SA-04-09",
        nameArabic: "الأسياح",
        nameEnglish: "Al Asyah",
        coordinates: [26.3258, 44.2042],
      },
      {
        id: "SA-04-10",
        nameArabic: "رياض الخبراء",
        nameEnglish: "Riyadh Al Khabra",
        coordinates: [25.9394, 44.1383],
      },
      {
        id: "SA-04-11",
        nameArabic: "الشماسية",
        nameEnglish: "Ash Shimasiyah",
        coordinates: [25.6492, 43.2056],
      },
      {
        id: "SA-04-12",
        nameArabic: "عقلة الصقور",
        nameEnglish: "Uqlat Assuqur",
        coordinates: [25.8558, 43.2347],
      },
      {
        id: "SA-04-13",
        nameArabic: "ضرية",
        nameEnglish: "Dhariyah",
        coordinates: [25.0022, 43.675],
      },
    ],
  },
  {
    areaId: "SA-05",
    areaNameArabic: "المنطقة الشرقية",
    areaNameEnglish: "Eastern Province",
    coordinates: [26.425699, 50.055164],
    governorates: [
      {
        id: "SA-05-01",
        nameArabic: "الدمام",
        nameEnglish: "Dammam",
        coordinates: [26.425699, 50.055164],
      },
      {
        id: "SA-05-02",
        nameArabic: "الهفوف",
        nameEnglish: "Al Hofuf",
        coordinates: [25.383333, 49.583333],
      },
      {
        id: "SA-05-03",
        nameArabic: "الخبر",
        nameEnglish: "Al Khobar",
        coordinates: [26.2172, 50.1971],
      },
      {
        id: "SA-05-04",
        nameArabic: "الأحساء",
        nameEnglish: "Al Ahsa",
        coordinates: [25.3957, 49.5775],
      },
      {
        id: "SA-05-05",
        nameArabic: "الجبيل",
        nameEnglish: "Al Jubail",
        coordinates: [27.0046, 49.6601],
      },
      {
        id: "SA-05-06",
        nameArabic: "رأس تنورة",
        nameEnglish: "Ras Tanura",
        coordinates: [26.707417, 50.067352],
      },
      {
        id: "SA-05-07",
        nameArabic: "النعيرية",
        nameEnglish: "An Nairyah",
        coordinates: [27.47496, 48.483724],
      },
      {
        id: "SA-05-08",
        nameArabic: "القطيف",
        nameEnglish: "Qatif",
        coordinates: [26.565191, 49.996376],
      },
      {
        id: "SA-05-09",
        nameArabic: "حفر الباطن",
        nameEnglish: "Hafar Al Batin",
        coordinates: [28.4328, 45.9703],
      },
      {
        id: "SA-05-10",
        nameArabic: "الخفجي",
        nameEnglish: "Al Khafji",
        coordinates: [28.4392, 48.4914],
      },
      {
        id: "SA-05-11",
        nameArabic: "بقيق",
        nameEnglish: "Buqayq",
        coordinates: [25.9256, 49.6897],
      },
      {
        id: "SA-05-12",
        nameArabic: "أبو حدرية",
        nameEnglish: "Abu Hadriyah",
        coordinates: [27.2758, 49.3069],
      },
      {
        id: "SA-05-13",
        nameArabic: "العديد",
        nameEnglish: "Al Udaid",
        coordinates: [25.3047, 49.1294],
      },
    ],
  },
  {
    areaId: "SA-06",
    areaNameArabic: "حائل",
    areaNameEnglish: "Hail",
    coordinates: [27.523647, 41.696632],
    governorates: [
      {
        id: "SA-06-01",
        nameArabic: "حائل",
        nameEnglish: "Hail",
        coordinates: [27.523647, 41.696632],
      },
      {
        id: "SA-06-02",
        nameArabic: "بقعاء",
        nameEnglish: "Baqa'a",
        coordinates: [28.2109, 42.5661],
      },
      {
        id: "SA-06-03",
        nameArabic: "الغزالة",
        nameEnglish: "Al Ghazalah",
        coordinates: [26.9622, 41.9861],
      },
      {
        id: "SA-06-04",
        nameArabic: "الشنان",
        nameEnglish: "Ash Shinan",
        coordinates: [27.0069, 41.0525],
      },
      {
        id: "SA-06-05",
        nameArabic: "السليمي",
        nameEnglish: "As Sulaymi",
        coordinates: [27.8656, 40.8486],
      },
      {
        id: "SA-06-06",
        nameArabic: "الحائط",
        nameEnglish: "Al Ha'it",
        coordinates: [27.7286, 41.2942],
      },
      {
        id: "SA-06-07",
        nameArabic: "الشملي",
        nameEnglish: "Ash Shamli",
        coordinates: [27.3061, 41.7431],
      },
      {
        id: "SA-06-08",
        nameArabic: "موقق",
        nameEnglish: "Mawqaq",
        coordinates: [28.0286, 41.3547],
      },
      {
        id: "SA-06-09",
        nameArabic: "سميراء",
        nameEnglish: "Sumayra",
        coordinates: [26.5858, 41.2139],
      },
    ],
  },
  {
    areaId: "SA-07",
    areaNameArabic: "تبوك",
    areaNameEnglish: "Tabuk",
    coordinates: [28.39722, 36.57889],
    governorates: [
      {
        id: "SA-07-01",
        nameArabic: "تبوك",
        nameEnglish: "Tabuk",
        coordinates: [28.39722, 36.57889],
      },
      {
        id: "SA-07-02",
        nameArabic: "ضباء",
        nameEnglish: "Duba",
        coordinates: [27.3506, 35.6902],
      },
      {
        id: "SA-07-03",
        nameArabic: "حقل",
        nameEnglish: "Haql",
        coordinates: [29.2806, 34.9352],
      },
      {
        id: "SA-07-04",
        nameArabic: "الوجه",
        nameEnglish: "Al Wajh",
        coordinates: [26.2458, 36.4556],
      },
      {
        id: "SA-07-05",
        nameArabic: "تيماء",
        nameEnglish: "Tayma",
        coordinates: [27.6342, 38.4983],
      },
      {
        id: "SA-07-06",
        nameArabic: "أملج",
        nameEnglish: "Umluj",
        coordinates: [25.0231, 37.2683],
      },
      {
        id: "SA-07-07",
        nameArabic: "البدع",
        nameEnglish: "Al Bada'",
        coordinates: [27.8056, 35.0028],
      },
    ],
  },
  {
    areaId: "SA-08",
    areaNameArabic: "الحدود الشمالية",
    areaNameEnglish: "Northern Borders",
    coordinates: [30.983334, 41.016666],
    governorates: [
      {
        id: "SA-08-01",
        nameArabic: "رفحاء",
        nameEnglish: "Rafha",
        coordinates: [29.6342, 43.5143],
      },
      {
        id: "SA-08-02",
        nameArabic: "عرعر",
        nameEnglish: "Arar",
        coordinates: [30.983334, 41.016666],
      },
      {
        id: "SA-08-03",
        nameArabic: "طريف",
        nameEnglish: "Turaif",
        coordinates: [31.6725, 38.6636],
      },
      {
        id: "SA-08-04",
        nameArabic: "العويقيلة",
        nameEnglish: "Al Uwayqilah",
        coordinates: [30.4817, 42.2769],
      },
    ],
  },
  {
    areaId: "SA-09",
    areaNameArabic: "جازان",
    areaNameEnglish: "Jazan",
    coordinates: [16.8893, 42.5511],
    governorates: [
      {
        id: "SA-09-01",
        nameArabic: "جازان",
        nameEnglish: "Jazan",
        coordinates: [16.8893, 42.5511],
      },
      {
        id: "SA-09-02",
        nameArabic: "صبيا",
        nameEnglish: "Sabya",
        coordinates: [17.1449, 42.6256],
      },
      {
        id: "SA-09-03",
        nameArabic: "الدرب",
        nameEnglish: "Ad Darb",
        coordinates: [17.7225, 42.2522],
      },
      {
        id: "SA-09-04",
        nameArabic: "أبو عريش",
        nameEnglish: "Abu Arish",
        coordinates: [16.9697, 42.8311],
      },
      {
        id: "SA-09-05",
        nameArabic: "صامطة",
        nameEnglish: "Samtah",
        coordinates: [16.5969, 42.9442],
      },
      {
        id: "SA-09-06",
        nameArabic: "بيش",
        nameEnglish: "Baysh",
        coordinates: [17.3192, 42.5978],
      },
      {
        id: "SA-09-07",
        nameArabic: "فرسان",
        nameEnglish: "Farasan",
        coordinates: [16.7028, 41.9925],
      },
      {
        id: "SA-09-08",
        nameArabic: "العارضة",
        nameEnglish: "Al Aridah",
        coordinates: [17.3139, 43.0928],
      },
      {
        id: "SA-09-09",
        nameArabic: "أحد المسارحة",
        nameEnglish: "Ahad Al Masarihah",
        coordinates: [16.7428, 43.0125],
      },
      {
        id: "SA-09-10",
        nameArabic: "الحرث",
        nameEnglish: "Al Harith",
        coordinates: [17.0394, 43.3789],
      },
      {
        id: "SA-09-11",
        nameArabic: "الريث",
        nameEnglish: "Ar Rayth",
        coordinates: [17.2042, 43.2139],
      },
      {
        id: "SA-09-12",
        nameArabic: "ضمد",
        nameEnglish: "Damad",
        coordinates: [16.7156, 42.9267],
      },
      {
        id: "SA-09-13",
        nameArabic: "فيفا",
        nameEnglish: "Fayfa",
        coordinates: [17.2389, 43.1167],
      },
      {
        id: "SA-09-14",
        nameArabic: "الداير",
        nameEnglish: "Ad Dayer",
        coordinates: [17.4547, 43.11],
      },
      {
        id: "SA-09-15",
        nameArabic: "العيدابي",
        nameEnglish: "Al Aidabi",
        coordinates: [16.9514, 42.6858],
      },
      {
        id: "SA-09-16",
        nameArabic: "هروب",
        nameEnglish: "Harub",
        coordinates: [17.5314, 42.3506],
      },
      {
        id: "SA-09-17",
        nameArabic: "الطوال",
        nameEnglish: "At Tuwal",
        coordinates: [17.4667, 42.8333],
      },
    ],
  },
  {
    areaId: "SA-10",
    areaNameArabic: "نجران",
    areaNameEnglish: "Najran",
    coordinates: [17.5656, 44.2289],
    governorates: [
      {
        id: "SA-10-01",
        nameArabic: "نجران",
        nameEnglish: "Najran",
        coordinates: [17.5656, 44.2289],
      },
      {
        id: "SA-10-02",
        nameArabic: "حبونا",
        nameEnglish: "Habuna",
        coordinates: [17.615, 44.5314],
      },
      {
        id: "SA-10-03",
        nameArabic: "ثار",
        nameEnglish: "Thar",
        coordinates: [17.4826, 43.507],
      },
      {
        id: "SA-10-04",
        nameArabic: "شرورة",
        nameEnglish: "Sharurah",
        coordinates: [17.4667, 47.1067],
      },
      {
        id: "SA-10-05",
        nameArabic: "بدر الجنوب",
        nameEnglish: "Badr Al Janoub",
        coordinates: [18.0153, 44.1167],
      },
      {
        id: "SA-10-06",
        nameArabic: "يدمة",
        nameEnglish: "Yadamah",
        coordinates: [17.28, 44.7044],
      },
      {
        id: "SA-10-07",
        nameArabic: "خباش",
        nameEnglish: "Khabbash",
        coordinates: [17.8333, 44.5],
      },
    ],
  },
  {
    areaId: "SA-11",
    areaNameArabic: "الباحة",
    areaNameEnglish: "Al Baha",
    coordinates: [20.0136, 41.4686],
    governorates: [
      {
        id: "SA-11-01",
        nameArabic: "الباحة",
        nameEnglish: "Al Baha",
        coordinates: [20.0136, 41.4686],
      },
      {
        id: "SA-11-02",
        nameArabic: "بلجرشي",
        nameEnglish: "Baljurashi",
        coordinates: [19.8516, 41.5608],
      },
      {
        id: "SA-11-03",
        nameArabic: "المندق",
        nameEnglish: "Al Mandaq",
        coordinates: [20.1906, 41.2809],
      },
      {
        id: "SA-11-04",
        nameArabic: "المخواة",
        nameEnglish: "Al Mikhwah",
        coordinates: [19.8067, 41.3683],
      },
      {
        id: "SA-11-05",
        nameArabic: "قلوة",
        nameEnglish: "Qilwah",
        coordinates: [19.6392, 41.6442],
      },
      {
        id: "SA-11-06",
        nameArabic: "العقيق",
        nameEnglish: "Al Aqiq",
        coordinates: [20.2942, 41.6789],
      },
      {
        id: "SA-11-07",
        nameArabic: "الحجرة",
        nameEnglish: "Al Hajrah",
        coordinates: [19.9869, 41.2278],
      },
      {
        id: "SA-11-08",
        nameArabic: "القرى",
        nameEnglish: "Al Qura",
        coordinates: [19.7014, 41.4431],
      },
      {
        id: "SA-11-09",
        nameArabic: "غامد الزناد",
        nameEnglish: "Ghamid Al Zinad",
        coordinates: [19.9333, 41.3667],
      },
      {
        id: "SA-11-10",
        nameArabic: "بني حسن",
        nameEnglish: "Bani Hasan",
        coordinates: [19.7, 41.5],
      },
    ],
  },
  {
    areaId: "SA-12",
    areaNameArabic: "الجوف",
    areaNameEnglish: "Al Jawf",
    coordinates: [29.9711, 40.2064],
    governorates: [
      {
        id: "SA-12-01",
        nameArabic: "سكاكا",
        nameEnglish: "Sakaka",
        coordinates: [29.9711, 40.2064],
      },
      {
        id: "SA-12-02",
        nameArabic: "دومة الجندل",
        nameEnglish: "Dumat Al Jandal",
        coordinates: [29.8153, 39.8655],
      },
      {
        id: "SA-12-03",
        nameArabic: "طبرجل",
        nameEnglish: "Tabarjal",
        coordinates: [30.4999, 38.216],
      },
      {
        id: "SA-12-04",
        nameArabic: "القريات",
        nameEnglish: "Al Qurayyat",
        coordinates: [31.3325, 37.3419],
      },
    ],
  },
  {
    areaId: "SA-13",
    areaNameArabic: "عسير",
    areaNameEnglish: "Asir",
    coordinates: [18.2465, 42.5117],
    governorates: [
      {
        id: "SA-13-01",
        nameArabic: "أبها",
        nameEnglish: "Abha",
        coordinates: [18.2465, 42.5117],
      },
      {
        id: "SA-13-02",
        nameArabic: "بيشة",
        nameEnglish: "Bisha",
        coordinates: [19.984, 42.5891],
      },
      {
        id: "SA-13-03",
        nameArabic: "تنومة",
        nameEnglish: "Tanomah",
        coordinates: [18.9128, 42.1401],
      },
      {
        id: "SA-13-04",
        nameArabic: "خميس مشيط",
        nameEnglish: "Khamis Mushait",
        coordinates: [18.3067, 42.7289],
      },
      {
        id: "SA-13-05",
        nameArabic: "النماص",
        nameEnglish: "Al Namas",
        coordinates: [19.1439, 42.1194],
      },
      {
        id: "SA-13-06",
        nameArabic: "محايل",
        nameEnglish: "Muhayil",
        coordinates: [18.5133, 42.0467],
      },
      {
        id: "SA-13-07",
        nameArabic: "سراة عبيدة",
        nameEnglish: "Sarat Abidah",
        coordinates: [18.2508, 42.6769],
      },
      {
        id: "SA-13-08",
        nameArabic: "أحد رفيدة",
        nameEnglish: "Ahad Rifaydah",
        coordinates: [18.1778, 42.7917],
      },
      {
        id: "SA-13-09",
        nameArabic: "رجال ألمع",
        nameEnglish: "Rijal Alma",
        coordinates: [18.2058, 42.2425],
      },
      {
        id: "SA-13-10",
        nameArabic: "تثليث",
        nameEnglish: "Tathlith",
        coordinates: [19.6539, 43.8539],
      },
      {
        id: "SA-13-11",
        nameArabic: "ظهران الجنوب",
        nameEnglish: "Dhahran Al Janoub",
        coordinates: [17.7097, 44.2158],
      },
      {
        id: "SA-13-12",
        nameArabic: "المجاردة",
        nameEnglish: "Al Majardah",
        coordinates: [18.6019, 41.8942],
      },
      {
        id: "SA-13-13",
        nameArabic: "البرك",
        nameEnglish: "Al Birk",
        coordinates: [18.9286, 41.6394],
      },
      {
        id: "SA-13-14",
        nameArabic: "بللسمر",
        nameEnglish: "Balasmar",
        coordinates: [18.0817, 42.6311],
      },
      {
        id: "SA-13-15",
        nameArabic: "بلقرن",
        nameEnglish: "Balgarn",
        coordinates: [19.6458, 41.7056],
      },
    ],
  },
];
